import React from "react";
import "./App.css";
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import HomeScreen from "./home/HomeScreen";
import ParentHomeScreen from "./Parent/ParentHomeScreen";
import InstagramScreen from "./Instagram/InstagramScreen";
import SpotifyScreen from "./Spotify/SpotifyScreen";
import NetflixScreen from "./Netflix/NetflixScreen";

const AppRoutes = () => {
  return useRoutes([
    { path: "/", element: <HomeScreen /> },
    { path: "/parent/:id?", element: <ParentHomeScreen /> },
    { path: "/marriagegram/:id?", element: <InstagramScreen /> },
    { path: "/marritify/:id?", element: <SpotifyScreen /> },
    { path: "/metflix/:id?", element: <NetflixScreen /> },
  ]);
};

function App() {
  return (
    <Router>
      <AppRoutes />
    </Router>
  );
}

export default App;
